import AnalyticsCard from "./AnalyticsCard";

export default function AnalyticsOverviewCards({
    cards = [],
}) {

    return (

        <div
            className="
                grid
                gap-6
                sm:grid-cols-2
                xl:grid-cols-3
            "
        >

            {cards.map((card) => (

                <AnalyticsCard
                    key={card.title}
                    title={card.title}
                    value={card.value}
                    subtitle={card.subtitle}
                />

            ))}

        </div>

    );

}